export default "/images/vendor/intl-tel-input/build/flags.webp?bd95ef49b665a571ca041e845485f680";